import { useEffect } from "react";
import { useRouter } from "next/router";
import { safeDdRumOnReady } from "@lululemon/ecom-site-utils";

/**
 * Custom hook for tracking views in Datadog RUM.
 *
 * @param {string} name -- The name of the view to be tracked. Can also be a function that returns a string.
 * @param {function} getContext -- A function that returns an object of context to be associated with the view.
 */

export const useTrackPageView = ({ name, getContext }) => {
  const { locale, asPath } = useRouter();

  useEffect(() => {
    safeDdRumOnReady(() => {
      const ddRum = window.DD_RUM;
      const { pathname } = location;
      const context =
        typeof getContext === "function" ? getContext(pathname, locale) : {};
      const viewName =
        typeof name === "function" ? name(pathname, locale) : name;

      ddRum.startView({
        name: viewName,
        context: {
          locale: locale || "en-us",
          ...context
        }
      });
    });
  }, [asPath, locale, name, getContext]);
};
